import type { BrowserInfo } from "./types";
import { isBrowser } from "./types";
import { parseChromiumMajorForTelemetry } from "./navigator";

export interface VisitInfo {
  domain: string;
  url: string;
  referrer: string;
}

/** Visit information (domain, URL, referrer) — zero-cost, synchronous. */
export function getVisitInfo(): VisitInfo {
  if (!isBrowser) return { domain: "", url: "", referrer: "" };
  try {
    const loc = window.location;
    return {
      domain: loc.hostname || "",
      url: loc.href || "",
      referrer: document.referrer || "",
    };
  } catch {
    return { domain: "", url: "", referrer: "" };
  }
}

export interface IncognitoProbeContext {
  isTopLevel: boolean;
  platform: string;
  uaPlatform?: string;
  chromiumMajorVersion: number | null;
  isIosChrome: boolean;
}

export function getIncognitoProbeContext(
  browser: Pick<BrowserInfo, "family" | "version" | "isIosChrome">,
): IncognitoProbeContext | undefined {
  if (!isBrowser) return undefined;
  return {
    isTopLevel: window === window.top,
    platform: typeof navigator.platform === "string" ? navigator.platform : "",
    uaPlatform: (navigator as any).userAgentData?.platform,
    chromiumMajorVersion: parseChromiumMajorForTelemetry(browser.version, browser.family),
    isIosChrome: !!browser.isIosChrome,
  };
}
